import { render, staticRenderFns } from "./CustomerRemoteSelect.vue?vue&type=template&id=c7ff09e6"
import script from "./CustomerRemoteSelect.vue?vue&type=script&lang=js"
export * from "./CustomerRemoteSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomerRemoteSelect.vue?vue&type=style&index=0&id=c7ff09e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports